export const primaryNavigation = [
  { label: 'Inicio', to: '/' },
  { label: 'Películas', to: '/peliculas' },
  { label: 'Cortometrajes', to: '/cortometrajes' },
  { label: 'Colecciones', to: '/colecciones' },
  { label: 'Sobre Nicole', to: '/sobre-nicole' },
];

export const footerNavigation = [
  {
    heading: 'Explorar',
    links: [
      { label: 'Inicio', to: '/' },
      { label: 'Películas', to: '/peliculas' },
      { label: 'Cortometrajes', to: '/cortometrajes' },
      { label: 'Colecciones', to: '/colecciones' },
    ],
  },
  {
    heading: 'NICOLE',
    links: [
      { label: 'Sobre Nicole', to: '/sobre-nicole' },
      { label: 'Buscar', to: '/buscar' },
      { label: 'Acceso privado', to: '/acceso' },
    ],
  },
];
